module.exports = __webpack_public_path__ + "static/media/summerCut-02.2fd12904.png";